<div class="content">
  <h3 class="title">¿El caso puede ser remitido?</h3>
  <p class="msg">{{ msg }}</p>

  <form [formGroup]="form">
    <div class="row">
      <div class="col-12" *ngIf="!isSingleDestination">
        <mat-form-field appearance="outline">
          <mat-label>Destino de la remisión</mat-label>
          <mat-select
            formControlName="caseType"
            (selectionChange)="onSelectionChange($event.value)"
          >
            <mat-option
              *ngFor="let dest of data.destinations"
              [value]="dest.remitTo._id"
            >
              {{ dest.remitTo.name }} (Unidad: {{ dest.remitTo.unit.name }})
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-12">
        <mat-form-field appearance="outline">
          <mat-label>Descripción</mat-label>
          <textarea matInput formControlName="description"></textarea>
        </mat-form-field>
      </div>
    </div>
  </form>

  <p class="subtitle" *ngIf="selectedDestination">
    El caso puede ser remitido a la unidad
    <strong>{{ selectedDestination.remitTo.unit.name }}</strong> al tipo de caso
    <strong>{{ selectedDestination.remitTo.name }}</strong>
  </p>

  <div class="button">
    <button mat-raised-button class="cancel-btn rounded" (click)="cancel()">
      Cancelar
    </button>
    <button
      mat-raised-button
      class="primary-btn rounded"
      [disabled]="!form.valid"
      (click)="create()"
    >
      Remitir caso
    </button>
  </div>
</div>
